import { defineStyleConfig } from "@chakra-ui/react";

export const textAreaTheme = defineStyleConfig({
	baseStyle: {
		border: "1px solid",
		borderColor: "neutrals.50",
		borderRadius: "md",
		height: "100%",
		width: "100%",
		resize: "none",
		padding: "8px",
		fontSize: "md",
		fontFamily: "forms",
		color: "neutrals.900",
		_invalid: {
			border: "1px solid",
			borderColor: "accent.red.300",
			bg: "accent.red.100",
		},
		_disabled: {
			bg: "form.disabled.background",
			color: "neutrals.100",
		},
		_focus: {
			outline: "none",
			zIndex: 1,
			bg: "neutrals.0",
			boxShadow: "0px 0px 3px 0px var(--chakra-colors-brand-400)",
			border: "1px solid",
			borderColor: " brand.400",
		},
	},
});
